import { Module } from 'vuex';
import { NodeNodeLoginHistoryExcludeConditionState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeNodeLoginHistoryExcludeConditionState = {
    nodeLoginHistoryExcludeConditions: undefined,
    nodeLoginHistoryExcludeConditionCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeNodeLoginHistoryExcludeCondition: Module<NodeNodeLoginHistoryExcludeConditionState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
